<div class="modal-header">
  <h4 class="modal-title float-left">Enter Reason</h4>
</div>
<div class="modal-body">
  <span class="ey-float-label ey-textarea-label" title="Enter a reason">
    <textarea
      appAutosize
      class="form-control"
      id="reason"
      name="reason"
      [(ngModel)]="reason"
      #searchCriteria="ngModel"
      maxlength="1000"
      minRows="2"
      minHeight="48"
      paddingHeight="32"
      appLabelFloat
    ></textarea>
    <label for="reason">Reason</label>
  </span>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="submitClick()">Submit</button>
</div>
